import { useState, useEffect, useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Radio, Eye } from "lucide-react";

export const LiveBanner = () => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [lives, setLives] = useState([]);

  const fetchLives = useCallback(async () => {
    try {
      const res = await api.get("/lives");
      setLives(res.data.lives || []);
    } catch (err) { console.error(err); }
  }, [api]);

  useEffect(() => {
    fetchLives();
    const interval = setInterval(fetchLives, 15000);
    return () => clearInterval(interval);
  }, [fetchLives]);

  if (lives.length === 0) return null;

  return (
    <div className="space-y-2" data-testid="live-banner">
      {lives.map((l) => (
        <button
          key={l.id}
          onClick={() => navigate(`/live/${l.id}`)}
          className="w-full bg-gradient-to-r from-red-500/10 to-[#FF6B35]/10 border border-red-500/20 rounded-2xl p-3 flex items-center gap-3 hover:border-red-500/40 transition-colors text-left group"
          data-testid={`live-card-${l.id}`}
        >
          <div className="relative">
            <div className="w-11 h-11 rounded-full bg-gradient-to-br from-red-500 to-[#FF6B35] flex items-center justify-center shrink-0">
              {l.artist_avatar ? (
                <img src={l.artist_avatar} alt="" className="w-full h-full rounded-full object-cover" />
              ) : (
                <span className="text-white font-heading font-bold text-sm">
                  {(l.artist_name || "?")[0].toUpperCase()}
                </span>
              )}
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
              <Radio className="w-2.5 h-2.5 text-white" />
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="bg-red-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider">Live</span>
              <span className="font-heading font-semibold text-sm text-foreground truncate group-hover:text-[#FF6B35] transition-colors">
                {l.artist_name}
              </span>
            </div>
            <p className="text-xs text-[#AFA8BA] truncate mt-0.5">{l.title}</p>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground shrink-0">
            <Eye className="w-3 h-3" />
            {l.viewer_count}
          </div>
        </button>
      ))}
    </div>
  );
};
